import type { MessageGroup, OrchestrationGroup } from "./messageGroups"

export function compactInline(value: string, maxLength = 96): string {
    const normalized = value.replace(/\s+/g, " ").trim()
    if (normalized.length <= maxLength) return normalized
    return `${normalized.slice(0, maxLength).trim()}...`
}

export function stringifyRaw(value: unknown): string {
    try {
        const json = JSON.stringify(value, null, 2)
        return json ?? String(value)
    } catch {
        return String(value)
    }
}

export function orchestrationGroupLabel(group: OrchestrationGroup): string {
    if (group.calls.length === 1 && group.calls[0]?.toolName === "update_plan") return "Plan updated"
    if (group.calls.length === 0) return "Tool batch"
    const allCommands = group.calls.every((call) => call.toolName === "exec_command")
    const noun = allCommands ? "command" : "call"
    return `Tool batch · ${group.calls.length} ${noun}${group.calls.length === 1 ? "" : "s"}`
}

function assertNever(value: never): never {
    throw new Error(`Unhandled message group: ${String(value)}`)
}

export function presentedGroupId(group: MessageGroup, index: number): string {
    switch (group.type) {
        case "text":
        case "thinking":
        case "system":
        case "result":
            return `${group.type}:${group.messageIndex}:${index}`
        case "tool":
        case "edit":
        case "write":
        case "bash":
        case "orchestration":
        case "todoWrite":
            return `${group.type}:${group.toolUseId}:${index}`
        case "fileChange":
            return `${group.type}:${group.toolUseId}:${group.changeIndex}:${index}`
        case "stderr":
            return `${group.type}:${group.eventId}:${index}`
        case "unknown":
            return `${group.type}:${group.harnessId}:${group.messageIndex}:${index}`
        case "activity":
            return `${group.type}:${group.harnessId}:${group.messageIndex}:${index}`
        case "providerNotice":
            return `${group.type}:${group.harnessId}:${group.kind}:${group.messageIndex}:${index}`
        case "agentActivity":
            return `${group.type}:${group.harnessId}:${group.messageIndex}:${index}`
        default:
            return assertNever(group)
    }
}
